import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAppStoreURL, APP_STORE_URL, PLAY_STORE_URL } from '../../utils/deviceDetection';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedinIn, 
  FaYoutube,
  FaApple,
  FaGooglePlay,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaArrowRight
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/about', label: t('nav.about') },
    { path: '/features', label: t('nav.features') },
    { path: '/pricing', label: t('nav.pricing') },
    { path: '/faq', label: t('nav.faq') },
    { path: '/contact', label: t('nav.contact') },
    { path: '/videos', label: 'Videos' },
  ];

  const supportLinks = [
    { path: '/faq', label: t('nav.faq') },
    { path: '/contact', label: t('nav.contact') },
    { path: '/privacy-policy', label: t('footer.privacy') },
    { path: '/terms-of-use', label: t('footer.terms') },
    { path: '/cancellation-policy', label: t('footer.cancellation') },
    { path: '/refund-policy', label: t('footer.refund') },
    { path: '/delete-account', label: 'Delete Account' }
  ];

  const legalLinks = [
    { path: '/cancellation-policy', label: t('footer.cancellation') },
    { path: '/refund-policy', label: t('footer.refund') }
  ];

  const socialLinks = [
    { icon: FaFacebookF, url: 'https://facebook.com', label: 'Facebook' },
    { icon: FaTwitter, url: 'https://twitter.com', label: 'Twitter' },
    { icon: FaInstagram, url: 'https://instagram.com', label: 'Instagram' },
    { icon: FaLinkedinIn, url: 'https://linkedin.com', label: 'LinkedIn' },
    { icon: FaYoutube, url: 'https://youtube.com', label: 'YouTube' }
  ];

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement newsletter subscription
    alert('Newsletter subscription coming soon!');
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/main_logo.png" alt="Land Tracker" className="logo-image" />
              <span className="gradient-text">Land Tracker</span>
            </div>
            <p className="footer-tagline">
              {t('footer.tagline')}
            </p>
            <div className="contact-info">
              <div className="contact-item">
                <FaEnvelope />
                <span>info@landtracker.app</span>
              </div>
              <div className="contact-item">
                <FaPhone />
                <span>+1 (555) 123-4567</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt />
                <span>{t('footer.location')}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-title">{t('footer.quickLinks')}</h3>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>
                    <FaArrowRight />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div className="footer-section">
            <h3 className="footer-title">{t('footer.support')}</h3>
            <ul className="footer-links">
              {supportLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path}>
                    <FaArrowRight />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div className="footer-section">
            <h3 className="footer-title">Download now</h3>
            {/* <p className="newsletter-text">{t('footer.newsletterText')}</p> */}
            {/* <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
              <input 
                type="email" 
                placeholder={t('footer.emailPlaceholder')}
                required
                className="newsletter-input"
              />
              <button type="submit" className="btn btn-primary">
                {t('footer.subscribe')}
              </button>
            </form> */}
            <div className="download-badges">
              <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="badge">
                <FaApple />
                <div>
                  <span>Download on the</span>
                  <strong>App Store</strong>
                </div>
              </a>
              <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer" className="badge">
                <FaGooglePlay />
                <div>
                  <span>Get it on</span>
                  <strong>Google Play</strong>
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} {t('footer.company')}. {t('footer.rights')}
            </p>
            {/* <div className="legal-links">
              {legalLinks.map((link) => (
                <Link key={link.path} to={link.path}>
                  {link.label}
                </Link>
              ))}
            </div> */}
            <div className="social-links">
              {socialLinks.map((social) => {
                const Icon = social.icon;
                return (
                  <a 
                    key={social.label}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className="social-link"
                  >
                    <Icon />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
